// Lifted condensation level (LCL) helpers.
// Source: Skysight bundle (docs/skysight-skewt-bundle.js, getTlcl/getPlcl).
//
// All temps in °C, pressures in hPa. LCL is the pressure/temperature where a
// dry-lifted surface parcel first reaches saturation — i.e. the cloudbase.

const POISSON = 2 / 7;   // R/cp for dry air

/**
 * Surface potential temperature (θ), referenced to 1050 hPa.
 *
 * This is the "θ at 1050" Skysight uses as the parcel-ascent anchor. Not the
 * standard θ-at-1000 — but it's what Skysight does, and the back-extrapolation
 * from 1050 ensures the parcel curve starts cleanly above any below-surface
 * artifacts.
 */
export function surfaceTheta(t0, p0) {
  return (t0 + 273.15) * Math.pow(1050 / p0, POISSON) - 273.15;
}

/**
 * Temperature at the LCL — Bolton (1980) eq 15.
 *
 * @param {number} t  - parcel temperature, °C
 * @param {number} s  - dewpoint, °C
 * @returns {number} LCL temperature, °C
 */
export function getTlcl(t, s) {
  return 1 / (1 / (s + 273.15 - 56) + Math.log((t + 273.15) / (s + 273.15)) / 800)
       + 56 - 273.15;
}

/**
 * Pressure at the LCL — Poisson equation.
 *
 * @param {number} p0    - surface pressure, hPa
 * @param {number} t0    - surface temperature, °C
 * @param {number} tlcl  - LCL temperature, °C (from getTlcl)
 * @returns {number} LCL pressure, hPa
 */
export function getPlcl(p0, t0, tlcl) {
  return p0 * Math.pow((tlcl + 273.15) / (t0 + 273.15), 1 / POISSON);
}
